import { CSSProperties, memo } from 'react';
import useWidthBreakpoint from '../../../../../../hooks/useWidthBreakpoint';
import { TxItem, txColor } from '../../txHelpers';
import { pick } from '../../responsive';
import SummaryPanel from '../shared/SummaryPanel';
import ListCandleChart from '../charts/ListCandleChart';

interface Props {
  tx: TxItem;
  isFirst: boolean;
  onToggle?: (id: number) => void;
}

const Row = ({ tx, isFirst, onToggle }: Props) => {
  const { breakpoint } = useWidthBreakpoint();
  const accentColor = txColor(tx.type);

  const wrapper: CSSProperties = pick<CSSProperties>(breakpoint, {
    sm: {
      display: 'flex',
      flexDirection: 'column',
      borderTop: isFirst ? '1px solid rgba(255,255,255,0.22)' : 'none',
      borderBottom: '1px solid rgba(255,255,255,0.22)',
      cursor: 'pointer',
      position: 'relative',
    },
    md: {
      display: 'flex',
      height: 240,
      borderTop: isFirst ? '1px solid rgba(255,255,255,0.22)' : 'none',
      borderBottom: '1px solid rgba(255,255,255,0.22)',
      cursor: 'pointer',
      position: 'relative',
    },
    lg: {
      display: 'flex',
      height: 240,
      borderTop: isFirst ? '1px solid rgba(255,255,255,0.22)' : 'none',
      borderBottom: '1px solid rgba(255,255,255,0.22)',
      cursor: 'pointer',
      position: 'relative',
    },
  });

  const accentBar: CSSProperties = pick<CSSProperties>(breakpoint, {
    sm: { height: 3, background: accentColor, flexShrink: 0 },
    md: { width: 3, background: accentColor, flexShrink: 0 },
    lg: { width: 3, background: accentColor, flexShrink: 0 },
  });

  const rail: CSSProperties = pick<CSSProperties>(breakpoint, {
    sm: {
      width: '100%',
      padding: '16px 18px',
      display: 'flex',
      flexDirection: 'column',
      gap: 12,
      borderBottom: '1px solid rgba(255,255,255,0.08)',
    },
    md: {
      width: 360,
      flexShrink: 0,
      padding: '20px 28px 20px 26px',
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
      borderRight: '1px solid rgba(255,255,255,0.08)',
    },
    lg: {
      width: 360,
      flexShrink: 0,
      padding: '20px 28px 20px 26px',
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
      borderRight: '1px solid rgba(255,255,255,0.08)',
    },
  });

  const chartContainer: CSSProperties = pick<CSSProperties>(breakpoint, {
    sm: { height: 180, position: 'relative', padding: '8px 18px' },
    md: { flex: 1, position: 'relative', padding: '16px 32px' },
    lg: { flex: 1, position: 'relative', padding: '16px 32px' },
  });

  return (
    <div
      className="nc-row-hover"
      style={wrapper}
      onClick={() => onToggle?.(tx.id)}
    >
      <div style={accentBar} />

      <div style={rail}>
        <SummaryPanel tx={tx} />
      </div>

      <div style={chartContainer}>
        <ListCandleChart txId={tx.id} />
      </div>
    </div>
  );
};

export default memo(Row);
